<template>
  <ViewNotFound
    v-if="isNotFound"
    :list="list"
    :value="searchValue"
    @onMountResult="$emit('onMountResult')"
  />
  <div v-else class="view-result">
    <SearchingLists
      v-if="providers.length || games.length"
      :providers="providers"
      :games="games"
      :search-value="searchValue"
      @onMountResult="$emit('onMountResult')"
    />
    <div v-if="isLoading && !data" class="view-result__loading" />
  </div>
</template>

<script>
import SearchingLists from '@/components/Lobby/SearchModal/components/SearchingLists'
import debounce from 'lodash/debounce'
import ViewNotFound from '@/components/Lobby/SearchModal/ViewNotFound'

const TIME_OUT = 500

export default {
  name: 'ViewResult',
  components: {
    SearchingLists,
    ViewNotFound,
  },
  props: {
    searchValue: { type: String },
    list: { type: Array },
  },
  data() {
    return {
      data: null,
      isLoading: false,
      onSearch: {},
    }
  },
  computed: {
    providers() {
      return this.data?.providers || []
    },
    games() {
      return this.data?.games || []
    },
    isNotFound() {
      return this.data && !this.data?.providers.length && !this.data?.games.length
    },
  },
  watch: {
    searchValue(v) {
      if (v.length < 3 || v.length > 100) return
      this.onSearch()
    },
    isNotFound(v) {
      this.$emit('onNotFoundResult', v)
    },
  },
  beforeMount() {
    this.searchHandler()
    this.onSearch = debounce(this.searchHandler, TIME_OUT)
  },
  methods: {
    async searchHandler() {
      this.isLoading = true
      try {
        const { data } = await this.$api._games.searchGamesProviders({ search: this.searchValue })
        this.data = data
      }
      catch (e) {
        console.log(e)
      }
      finally {
        this.isLoading = false
      }
      this.$nextTick(() => {
        this.$emit('onMountResult')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.view-result {
  &__title {
    text-align: left;

    @include media(tablet) {
      text-align: center;
    }
  }

  &__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 70%;
    background-image: url('/img/loaders/loader.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 36px auto;
  }
}
</style>
